import { Skeleton } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import Page from "../../Common/Page";
import { useFetchMatchProfile } from "../../entities/api";
import ManageMatchProfileForm from "./ManageMatchProfileForm";

const ManageMatchProfile = () => {
  const { matchProfileId } = useParams();
  const { formatMessage } = useIntl();
  const { data, isLoading } = useFetchMatchProfile();

  const title = useMemo(() => {
    return matchProfileId
      ? `${formatMessage({
          id: "manage",
          defaultMessage: "Manage",
        })} ${data?.name}`
      : `${formatMessage({
          id: "match.profile.add",
          defaultMessage: "Add Match Profile",
        })}`;
  }, [matchProfileId, formatMessage, data?.name]);

  if (isLoading) {
    return <Skeleton />;
  }

  if (matchProfileId && !Object.keys(data || {})?.length) {
    return <Skeleton />;
  }

  return (
    <Page title={title} tabTitle={title}>
      <ManageMatchProfileForm matchProfile={data} />
    </Page>
  );
};

export default ManageMatchProfile;
